import o from '../../../../../node_modules/.pnpm/jwt-decode@3.1.2/node_modules/jwt-decode/build/jwt-decode.esm.js';
import { makeObservable, observable, computed, action } from 'mobx';
import AuthState from './Models/AuthState.js';
import LoggerFactory from '../../Util/Logger/LoggerFactory.js';
import { logoutEvent, loginEvent } from '../../Events/commonEvents.js';
import { ApiRole } from '@ibe/api';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
    this.logger = LoggerFactory.get('AuthService');
    this.jwtDecode = o;
    this.authState = new AuthState();
    makeObservable(this, {
      authState: observable,
      state: computed,
      isLoggedIn: computed,
      fromJwt: action,
      abort: action,
      authenticate: action,
      invalidate: action,
      updateState: action
    });
  }
  _createClass(AuthService, [{
    key: "state",
    get: function get() {
      return this.authState;
    }
  }, {
    key: "isLoggedIn",
    get: function get() {
      return this.authState.isLoggedIn;
    }
  }, {
    key: "fromJwt",
    value: function fromJwt(token) {
      try {
        var tokenDecoded = this.decode(token);
        if (tokenDecoded) {
          var _tokenDecoded$USER_ID;
          var user = {
            id: ((_tokenDecoded$USER_ID = tokenDecoded.USER_ID) === null || _tokenDecoded$USER_ID === void 0 ? void 0 : _tokenDecoded$USER_ID.toString()) || undefined,
            username: tokenDecoded.USER_NAME,
            lastName: tokenDecoded.LASTNAME,
            lastname: tokenDecoded.LASTNAME,
            firstname: tokenDecoded.FIRSTNAME,
            firstName: tokenDecoded.FIRSTNAME
          };
          var agency = {
            number: tokenDecoded.AGENCY_NUMBER,
            language: tokenDecoded.LANGUAGE,
            currency: tokenDecoded.CURRENCY
          };
          var newState = {
            firstName: tokenDecoded.FIRSTNAME,
            lastName: tokenDecoded.LASTNAME,
            user: user,
            agency: agency,
            role: tokenDecoded.ROLE,
            token: token,
            isAgency: !!tokenDecoded.AGENCY_NUMBER,
            isLoggedIn: !!tokenDecoded.USER_ID && tokenDecoded.ROLE !== ApiRole.GUEST,
            isGuest: tokenDecoded.ROLE === ApiRole.GUEST
          };
          this.updateState(newState);
        }
      } catch (e) {
        this.logger.warn(e);
        this.abort('Could not create state from token.');
      }
    }
  }, {
    key: "getRemainingTokenTime",
    value: function getRemainingTokenTime() {
      if (!this.authState || !this.authState.token) {
        return null;
      }
      var expirationTime = null;
      var token = this.state.token;
      if (token) {
        var tokenDecoded = this.decode(token);
        if (tokenDecoded) {
          expirationTime = tokenDecoded.exp * 1000 - Date.now();
        }
      }
      return expirationTime;
    }
  }, {
    key: "getTokenExpiration",
    value: function getTokenExpiration() {
      if (!this.authState || !this.authState.token) {
        return null;
      }
      var expirationTime = null;
      var token = this.state.token;
      if (token) {
        var tokenDecoded = this.decode(token);
        if (tokenDecoded) {
          expirationTime = tokenDecoded.exp * 1000 - tokenDecoded.iat * 1000;
        }
      }
      return expirationTime;
    }
  }, {
    key: "decode",
    value: function decode(token) {
      return this.jwtDecode(token);
    }
  }, {
    key: "abort",
    value: function abort(because) {
      this.invalidate();
      throw new Error(because);
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      this.updateState(new AuthState());
      logoutEvent.broadcast();
    }
  }, {
    key: "authenticate",
    value: function authenticate(token) {
      this.fromJwt(token);
      if (this.authState.isLoggedIn) {
        loginEvent.broadcast(this.authState);
      }
    }
  }, {
    key: "updateState",
    value: function updateState(state) {
      this.authState = state;
    }
  }]);
  return AuthService;
}();

export { AuthService as default };
//# sourceMappingURL=AuthService.js.map
